import { useEffect, useState } from "react";

/**
 * Hook for theme management. Persists choice to localStorage and applies
 * `data-theme="light" | "dark"` attribute to <html>.
 */
const KEY = "stb_theme";

function getInitial() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark") return v;
  } catch {
    /* SSR / locked storage */
  }
  return "dark";
}

export function useTheme() {
  const [theme, setTheme] = useState(getInitial);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      /* ignore */
    }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return { theme, setTheme, toggle };
}
